module.exports = __webpack_public_path__ + "static/media/tlyfe.232d7ad6.png";